import React, { useEffect, useState } from "react";
import axios from 'axios';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Banner = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STRAPI_API_URL}/banners?populate=*`, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
      },
    }).then(res => {
      setSlides(res.data.data);
    }).catch(err => console.error(err));
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    fade: true,
  };

  return (
    <div className="relative h-[75vh] overflow-hidden">
      <Slider {...settings} className="h-full">
        {slides.map((items) => {
          const { title, subtitle } = items;

          return items.image.map((item, i) => {
            const imgUrl = process.env.REACT_APP_STRAPI_URL + item?.formats?.large?.url;
            return (
              <div key={i} className="h-screen">
                <img
                  src={imgUrl}
                  alt=""
                  className="object-cover w-full h-full"
                />

                <div className="absolute inset-0 flex flex-col justify-center items-center text-white text-center px-6 z-10 bg-black bg-opacity-30">
                  <h1 className="text-4xl md:text-6xl font-extrabold mb-6 drop-shadow-md">
                    {title}
                  </h1>
                  <p className="max-w-2xl mb-6 text-lg md:text-xl">
                    {subtitle}
                  </p>
                  <button className="bg-yellow-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-yellow-500 transition">
                    Khám Phá Thêm
                  </button>
                </div>
              </div>
            );
          });
        })}
      </Slider>
    </div>
  );
};

export default Banner;
